export default "__VITE_ASSET__37cafc92__"